// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui-title[data-v-1d540dac] {\n\tmargin-top: 0;\n}\n", ""]);
// Exports
module.exports = exports;
